module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Display#3-a5e0649348a2d3b91e42211d9d3233c8.svg";